// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__HbLdF","body":"footer_body__Gx6RB","bodyInner":"footer_bodyInner__hk20j"};